export default {
  countries (state) {
    return state.countries
  }
}
